
import { mapGetters } from "vuex";
import { getImageByPosition, metaGenerator, normalizeI18nLinks, getPageFromQuery } from "@/utils";
import useEvents from "~/mixins/useEvents";
import ArticlesList from "@/components/pages/articles/ArticlesList.vue";
import UiBreadcrumbs from "~/components/UI/UiBreadcrumbs.vue";

export default {
  name: "Index",
  components: {
    UiBreadcrumbs,
    ArticlesList,
  },
  mixins: [useEvents],
  async asyncData({ $api, store, route, error }) {
    const getBlogCategory = async () => {
      try {
        const { data } = await $api.blog.getBlogCategoryBySlug(route.params.section);
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };

    const blogCategory = await getBlogCategory();

    store.commit("general/SET_JSON_SCHEMA_DATA", {
      pageName:
        blogCategory?.mixedTranslation?.title,
      pageImage:
        getImageByPosition(blogCategory?.medias, "page")?.file?.url ||
        getImageByPosition(blogCategory?.medias, "list")?.file?.url,
    });

    return {
      blogCategory,
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: {
        // TODO remove after reindex
        canonicalQueries: getPageFromQuery(this.$route.query.page) === 1 ? false : ["page"],
      },
    });
    const titleTemplate = `%s | ${this.getCompanyName}`;
    let description =
      this.$t("articleDescription") +
      ` ${this.blogCategory?.mixedTranslation.title}`;
    const currentPage = getPageFromQuery(this.$route.query.page);
   
      if (currentPage > 1) {
      description += ` | ${this.$t("page")} ${currentPage}`;
    }
    
    return {
      meta: [
        ...metaGenerator({
          title:
            this.blogCategory?.mixedTranslation?.meta_title ||
            this.blogCategory?.mixedTranslation?.title ||
            "",
          description,
          image:
            this.blogCategory?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          keywords: this.blogCategory?.mixedTranslation?.meta_keywords || "",
          url:
            this.blogCategory?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: normalizeI18nLinks(i18nHead.link),
      title:
        this.blogCategory?.mixedTranslation?.meta_title || this.blogCategory?.mixedTranslation?.title || "",
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
  },
  methods: {
    setBreadcrumbs() {
      this.$store.commit("general/SET_BREADCRUMBS", [
        {
          text: this.$t("home"),
          disabled: false,
          href: this.localePath("/"),
        },
        {
          text: this.$t("articles"),
          disabled: false,
          href: this.localePath("/articles"),
        },
        {
          text: this.blogCategory?.mixedTranslation?.title,
          disabled: true,
          href: this.localePath(
            `/articles/${this.blogCategory?.slug}`
          ),
        },
      ]);
    },
  },
  created() {
    this.setBreadcrumbs();
  },
  mounted () {
    this.visitEvent();
  },
};
